// Split out of TrajectoryTrailOverlay.tsx (react-refresh/only-export-components)
// — a pure color-math helper, not a component. Behavior unchanged.
//
// Design rationale:
//   - Faster motion → darker, more saturated dot (the point pushes "into" the
//     visual field — speed feels heavy and grounded).
//   - Slower motion → lighter, slightly desaturated dot (floaty, suspended).
//   - All modulation is in HSL so we can dial lightness independently of hue.
//
// velocityRatio: 0 (still) → 1 (max velocity observed across all frames).

/**
 * Returns the fill color for a dot at the given velocity ratio.
 *
 * At velocityRatio=0 → lightness 60%, saturation 60% (light/pale).
 * At velocityRatio=1 → lightness 20%, saturation 95% (dark/deep).
 *
 * The `hue` comes from the per-landmark palette entry.
 */
export function dotFillColor(hue: number, velocityRatio: number): string {
  const ratio = Math.max(0, Math.min(1, velocityRatio));
  const lightness  = Math.round(60  - ratio * 40);   // 60 → 20
  const saturation = Math.round(60  + ratio * 35);   // 60 → 95
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
